import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './index.scss'
import workData from '../../data/workExperience.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

const WorkTermReport = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const workItem = workData.find((item, index) => index.toString() === id)

  if (!workItem) {
    return (
      <div className="work-report-page">
        <div className="work-container">
          <p>Report not found.</p>
          <button className="back-btn" onClick={() => navigate('/work')}>
            <FontAwesomeIcon icon={faArrowLeft} /> Back to Work Experience
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="work-report-page">
      <div className="work-container">
        <div className="report-navigation">
          <button className="back-btn" onClick={() => navigate('/work')}>
            <FontAwesomeIcon icon={faArrowLeft} /> Back to Work Experience
          </button>
        </div>

        <div className="report-hero">
          <div className="hero-content">
            <div className="report-badge">Work Term Report</div>
            <h1 className="report-title">{workItem.role}</h1>
            <div className="report-meta">
              <div className="meta-item">
                <span className="meta-label">Company:</span>
                <span className="meta-value">{workItem.company}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Location:</span>
                <span className="meta-value">{workItem.location}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Duration:</span>
                <span className="meta-value">{workItem.start} — {workItem.end || 'Present'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="report-content">
          {workItem.description && (
            <section className="content-section overview-section">
              <div className="section-header">
                <h2 className="section-title">Overview</h2>
                <div className="section-icon">📋</div>
              </div>
              <div className="section-content">
                <p className="overview-text">{workItem.description}</p>
              </div>
            </section>
          )}

          {workItem.companyDescription && (
            <section className="content-section company-section">
              <div className="section-header">
                <h2 className="section-title">About {workItem.company}</h2>
                <div className="section-icon">ℹ️</div>
              </div>
              <div className="section-content">
                <p className="company-text">{workItem.companyDescription}</p>
              </div>
            </section>
          )}

          {workItem.achievements && workItem.achievements.length > 0 && (
            <section className="content-section achievements-section">
              <div className="section-header">
                <h2 className="section-title">Key Responsibilities</h2>
                <div className="section-icon">🏆</div>
              </div>
              <div className="section-content">
                <ul className="achievements-list">
                  {workItem.achievements.map((achievement, idx) => (
                    <li key={idx} className="achievement-item">
                      <span className="achievement-bullet">✓</span>
                      <span className="achievement-text"><strong>{achievement.split(':')[0]}:</strong>{achievement.split(':').slice(1).join(':')}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          )}

          {workItem.challenges && workItem.challenges.length > 0 && (
            <section className="content-section challenges-section">
              <div className="section-header">
                <h2 className="section-title">Goals and Learning Outcomes</h2>
                <div className="section-icon">🎯</div>
              </div>
              <div className="section-content">
                <ul className="challenges-list">
                  {workItem.challenges.map((challenge, idx) => (
                    <li key={idx} className="challenge-item">
                      <span className="challenge-bullet">🔧</span>
                      <span className="challenge-text"><strong>{challenge.split(':')[0]}:</strong>{challenge.split(':').slice(1).join(':')}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          )}

          {workItem.learning && (
            <section className="content-section learning-section">
              <div className="section-header">
                <h2 className="section-title">What I Learned</h2>
                <div className="section-icon">📚</div>
              </div>
              <div className="section-content">
                <div className="learning-content">
                  <p>{workItem.learning}</p>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  )
}

export default WorkTermReport